import AppPanel from './AppPanel';

export default AppPanel;
